/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LocationDeviceResponse } from '../../models/location-device-response';

export interface GetDevices$Params {
}

export function getDevices(http: HttpClient, rootUrl: string, params?: GetDevices$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LocationDeviceResponse>>> {
  const rb = new RequestBuilder(rootUrl, getDevices.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LocationDeviceResponse>>;
    })
  );
}

getDevices.PATH = '/locations/devices';
